// Lib
import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Selectors
import getGridSize from '../../../utils/grid/gridSizeSelector';
import { getCurrentBoardId } from '../../../reducers/currentBoardId/currentBoardIdSelector';
import { currentBoardIsPublishedSelector } from '../../../utils/permissions/elementPermissionsSelector';
import { currentBoardEditorsAvatarInfoSelector } from '../../../workspace/header/currentBoardHeader/sharing/headerShareUtilSelector';

// Hooks
import useFetchBoardSharingData from '../../../workspace/header/currentBoardHeader/sharing/useFetchBoardSharingData';

// Actions
import { openSheet } from '../../structural/sheet/sheetActions';

// Components
import Icon from '../../../components/icons/Icon';
import Button from '../../../components/buttons/Button';
import HeaderShareAvatars from '../../../workspace/header/currentBoardHeader/sharing/HeaderShareAvatars';

// Constants
import { SheetId } from '../../structural/sheet/sheetTypes';

// Styles
import './MobileShareUtil.scss';

const MobileShareUtil = (): ReactElement => {
    const gridSize = useSelector(getGridSize);
    const currentBoardId = useSelector(getCurrentBoardId);
    const currentBoardIsPublished = useSelector(currentBoardIsPublishedSelector);
    const currentBoardEditorsAvatarInfo = useSelector(currentBoardEditorsAvatarInfoSelector);

    useFetchBoardSharingData();

    const hideShareIcon = currentBoardIsPublished || currentBoardEditorsAvatarInfo.length > 0;

    const dispatch = useDispatch();

    const openMobileShareSheet = () => dispatch(openSheet(SheetId.Sharing));

    return (
        <div className="MobileShareUtil">
            {hideShareIcon ? (
                <HeaderShareAvatars
                    currentBoardId={currentBoardId}
                    gridSize={gridSize}
                    users={currentBoardEditorsAvatarInfo}
                    userAvatarLimit={3}
                    userAvatarSize={28}
                    dispatchOpenShareModal={openMobileShareSheet}
                />
            ) : (
                <Button className="HeaderShareButton" onClick={openMobileShareSheet}>
                    <Icon name="share" />
                </Button>
            )}
        </div>
    );
};

export default MobileShareUtil;
